export const CuttingPermissions = {
  "General Manager": [],
  "Asst. General Manager": [],
  Manager: [
    {
      path: "/cutting/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/cutting/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/cutting/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/cutting/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Cutting Incharge": [
    {
      path: "/cutting/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/cutting/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Incharge: [
    {
      path: "/cutting/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/cutting/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Executive: [],
  "Jr. Executive": [],
  "Sr. Executive": [],
};
